import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { Router } from '@angular/router';
import { UserMgmtService } from "../../user-management/user-management.service";
import { ExcelService } from "../../dashboard/excel.service";
@Component({
  selector: 'app-userlogs',
  templateUrl: './userlogs.component.html',
  styleUrls: ['./userlogs.component.scss']
})
export class UserlogsComponent implements OnInit {
  @ViewChild(DatatableComponent,{ static: false }) table: DatatableComponent;
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;
  userId: number;
  statusForm: FormGroup;
  resetPasswordForm: FormGroup;
  subscriptiondata: any;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "In-Active" },
    { id: "suspended", name: "Suspended" },
    { id: "blocked", name: "Blocked" }
  ];
  userlist = [];
  dataShowList = [];
  activityList = [];
  temp = [];
  // userlist = [{ firstname: "Manish", lastName: "Singh", email: "inder@gmail.com ", status: "Active", creationDate: "1565695077" },
  // { firstname: "khurana", lastName: "khurana", email: "khurana@gmail.com ", status: "Blocked", creationDate: "1565695077" }];

  columns = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 50 ;
  offset: number = 0 ;
  rowCount:number = 0 ;
  userSearchType: number = 0;
  startDateEpoch: any;
  endDateEpoch: any;
  startDateObj = { year: null, month: null, day: null };
  endDateObj = { year: null, month: null, day: null };
  startDate: any;
  endDate: any;
  usercount: any;
  downloadList: Array<object> = [];
  paymentHistList:Array<object> = [];
  DateRangeQuery: string = "";
  // paymentHistList=[{
  //   lastPaymentDate:1584448638,
  //   lastSubscriptionAmount:20,
  //   brand:'visa',
  //   last4:'3832'
  // }];
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"sm"
  };

  inviteCode:string = '';
  searchText: string = "";
  yearList = [];
  year:any;
  monthList = [
    {label:'January',value:1},
    {label:'February',value:2},
    {label:'March',value:3},
    {label:'April',value:4},
    {label:'May',value:5},
    {label:'June',value:6},
    {label:'July',value:7},
    {label:'August',value:8},
    {label:'September',value:9},
    {label:'October',value:10},
    {label:'November',value:11},
    {label:'December',value:12},
  ]
  monthSelect:any;
  yearSelect :any;
  isLoading:boolean = false;
  constructor(
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ExcelService: ExcelService
  ) { }

  ngOnInit() {
    this.yearSelect =new Date().getFullYear();
    this.monthSelect= new Date().getMonth();
    this.getCurrentMonth();
    this.getUserList();
   this.getdownloadList();
  }
  reset() {
    this.offset = 0;
    this.textSearch = '';
    this.inviteCode='';
    this.getCurrentMonth();
    this.getUserList();
  
  }
  getCurrentMonth() {
    this.startDate = new Date(this.yearSelect, this.monthSelect, 1);
    this.endDate = new Date(this.yearSelect, this.monthSelect + 1, 0);     
  }
   getEpoc(date) {
    let epocDate = new Date(date).setHours(0, 0, 0, 0)/1000;
    return epocDate
  }
  getEpocEnd(date) {
    let epocDate = new Date(date).setHours(23, 59, 59, 0)/1000;
    return epocDate;
  }

  getUserList() {
    this.spinner.show();
    let query ="";
    if(this.startDate && this.endDate) {
      query  = query+ "&role=user&startTime=" + this.getEpoc(this.startDate) + "&endTime=" + this.getEpocEnd(this.endDate);
    }
    if(this.inviteCode){
      query = query+"&inviteCode="+this.inviteCode
    }
    if (this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
    
    this.userMgmtService.getUserlogsDownload(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        let tempList=res.data.users;
        this.dataShowList = [];
         tempList.forEach(element => {
           let comunity:any;
           let  course:any;
           let  appTime:any;
           let monitorTime:any;
           
           appTime =element['totalTime'];
           for (let i = 0; i < element['timings'].length; i++) {
             if(element['timings'][i]['type'] == 'courseTime'){
               course = element['timings'][i]['overallTime'];
             }
             if(element['timings'][i]['type'] == 'communityTime'){
               comunity = element['timings'][i]['overallTime'];
             }
             
             if(element['timings'][i]['type'] == 'monitorTime'){
               monitorTime = element['timings'][i]['overallTime'];
             }
             
           }
           if(element['status'] =='deleted' ){
             element['email'] =element['deletedDetails']['email'];
            // element['firstName'] =element['deletedDetails']['firstName'];
            // element['firstName'] =element['deletedDetails']['lastName'];
           }
           let Obj={
             Name:element['firstName'] +" "+ element['lastName'],
             Email:element['email'] || 'NA', 
             InviteCode:element['inviteCode'] || 'NA', 
             Time_Spent_On_App:this.display(appTime), 
             CourseTime: this.display(course) ,
             CommunityTime:this.display(comunity), 
             MonitorTime:this.display(monitorTime)
           }
         this.dataShowList.push(Obj)
         });
        
        this.rowCount = this.dataShowList.length;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        // this.userlist = [];
      }
    });
  }
  onChangePageLimit(){
    this.getUserList()

  }
  textSearch:string = ''
  applySearch() {
    this.offset =0
    // this.getCurrentMonth();
    let query= "";
    this.spinner.show();
    if(this.startDate && this.endDate) {
      query  = query+ "&role=user&startTime=" + this.getEpoc(this.startDate) + "&endTime=" + this.getEpocEnd(this.endDate);
    }
 
    if (this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
    if(this.inviteCode){
      query = query+"&inviteCode="+this.inviteCode
    }
     query= query+"&limit="+this.pageLimit+"&offset="+this.offset;
     this.getdownloadList();
      this.dataShowList = [];
    this.userMgmtService.getUserlogsDownload(query).subscribe(res => {

      if ((res["message"] == "Success")) {  
        this.dataShowList =[];
      res.data.users.forEach(element => {
          let comunity:any;
          let  course:any;
          let  appTime:any;
          let monitorTime:any;
   
          for (let i = 0; i < element['timings'].length; i++) {
            if(element['timings'][i]['type'] == 'courseTime'){
              course = element['timings'][i]['overallTime'];
            }
            if(element['timings'][i]['type'] == 'communityTime'){
              comunity = element['timings'][i]['overallTime'];
            }
            if(element['timings'][i]['type'] == 'appTime'){
              appTime = element['timings'][i]['overallTime'];
            }
            if(element['timings'][i]['type'] == 'monitorTime'){
              monitorTime = element['timings'][i]['overallTime'];
            }
          }
          
          element['Time_Spent_On_App']=this.display(appTime);
          element['CourseTime']=this.display(course);
          element['CommunityTime']=this.display(comunity);
          element['MonitorTime']=this.display(monitorTime);
          this.dataShowList.push(element)

        });
        this.rowCount = this.dataShowList.length;
        this.spinner.hide();
      } else {

        // this.userlist = [];
      }

    });
    this.spinner.hide();
  }
  setPage(pageInfo) {
      this.offset = this.pageLimit * pageInfo.offset;
      this.applySearch();
    
  }



  moreDetailModal(content, btn, userId) {
    let query = "userId=" + userId;
    if(this.startDate && this.endDate) {
      query  = query+ "&startTime=" + this.startDate/1000 + "&endTime=" + this.endDate/1000;
    }
    this.spinner.show();
    this.userMgmtService.getUserTimeActivity(query).subscribe(
      (res) => {
        this.spinner.hide();
        if (res["message"] == "Success") {
          this.activityList = [];
          res.data.userTimings.forEach(element => {
            this.activityList.push(element);
          });
          this.modelOptions = {
            backdrop: "static",
            keyboard: false,
            centered: true,
            size: 'lg',
          };

          btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
          this.modalRef = this.modalService.open(content, this.modelOptions);
          this.modalRef.result.then(
            result => {
              this.closeResult = `Closed with: ${result}`;
            },
            reason => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
          );

        } else {

        }
      },
      (err) => {
        this.spinner.hide();
      }
    );

  }

  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.ExcelService.exportAsExcelFile(this.dataShowList,"UserTime_"+ month + "/" + day + "/" + year);
  }
  
  getdownloadList(){
    let query ='role=user';
    if(this.startDate && this.endDate) {
      query  = query+ "&startTime=" + this.getEpoc(this.startDate) + "&endTime=" + this.endDateEpoch(this.endDate);
    }
    if(this.inviteCode){
      query = query+"&inviteCode="+this.inviteCode
    }
    if (this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
    this.userMgmtService.getUserlogsDownload(query).subscribe(res => {
      if ((res["message"] == "Success")) {
     let tempList=res.data.users;
     this.downloadList = [];
      tempList.forEach(element => {
        let comunity:any;
        let  course:any;
        let  appTime:any;
        let monitorTime:any;
 
        for (let i = 0; i < element['timings'].length; i++) {
          if(element['timings'][i]['type'] == 'courseTime'){
            course = element['timings'][i]['overallTime'];
          }
          if(element['timings'][i]['type'] == 'communityTime'){
            comunity = element['timings'][i]['overallTime'];
          }
          if(element['timings'][i]['type'] == 'appTime'){
            appTime = element['timings'][i]['overallTime'];
          }
          if(element['timings'][i]['type'] == 'monitorTime'){
            monitorTime = element['timings'][i]['overallTime'];
          }
        }
        
        let Obj={
          Name:element['firstName'] +" "+ element['lastName'],
          Email:element['email'] || 'NA', 
          InviteCode:element['inviteCode'] || 'NA',
          Time_Spent_On_App:this.display(appTime), 
          CourseTime: this.display(course) ,
          CommunityTime:this.display(comunity), 
          MonitorTime:this.display(monitorTime)
        }
      this.downloadList.push(Obj)
      });
      } else {
      }
    });

  }
  display (seconds) {
    const format = val => `0${Math.floor(val)}`.slice(-2)
    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
  
    return [hours || 0, minutes || 0, (seconds % 60)|| 0 ].map(format).join(':') ;
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



}

